import { Component, Input, OnInit } from "@angular/core"
import { News } from "src/app/models"
import { DatePipe } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatSelectModule } from "@angular/material/select";
import { ObjectKeysPipe } from "../../pipes/object-keys.pipe";
import { StripHtmlPipe } from "../../pipes/strip-html.pipe"
import { MatIcon } from "@angular/material/icon"

@Component({
    selector: "valben-news-history",
    templateUrl: "./news-history.component.html",
    styles: [`
        b {
            white-space: nowrap;
        }
    `],
    standalone: true,
    imports: [
        FormsModule,
        MatFormFieldModule,
        MatSelectModule,
        MatIcon,
        DatePipe,
        ObjectKeysPipe,
        StripHtmlPipe,
    ],
})

export class NewsHistoryComponent implements OnInit {
    @Input() values: News[] = []
    nameLangs: string[] = []
    descLangs: string[] = []

    ngOnInit(): void {
        this.nameLangs = this.values.map(_ => "hr")
        this.descLangs = this.values.map(_ => "hr")
    }
}

